import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { BusinessProfileAIAPI } from "../../Utils/Api/BusinessProfileAIAPI";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import logo from "../../assets/shoplocal logo.svg";
import communityXlogo from "../../assets/communityXlogo.svg";
import subHeadingImage from "../../assets/business profile logo.svg";
import regnerateIcon from "../../assets/regenerate icon.svg";
import copyIcon from "../../assets/copy icon.svg";
import MultiSelectDropdown from "../../Components/MultiSelectDropdown/MultiSelectDropdown";
import SelectDropdown from "../../Components/SelectDropdown/SelectDropdown";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";

const ShopLocalAIBusinessProfile = () => {
  // form data initial values
  const [formData, setFormData] = useState({
    businessType: "",
    businessCategory: "",
    yearsInBusiness: "",
    sentimentType: [],
    customerType: [],
  });
  const businessOptions = [
    { name: "Product", id: 1 },
    { name: "Service", id: 2 },
    { name: "Product & Service", id: 3 },
  ];
  const sentimentOptions = [
    { name: "Professionalism", id: 1 },
    { name: "Innovativeness", id: 2 },
    { name: "Trustworthiness", id: 3 },
    { name: "Customer-Centric", id: 4 },
    { name: "Adaptability", id: 5 },
    { name: "Exceptional Service", id: 6 },
    { name: "Collaborative", id: 7 },
    { name: "Community Oriented", id: 8 },
    { name: "Quality and Excellence", id: 9 },
    { name: "Authenticity", id: 10 },
  ];
  const customerOptions = [
    { name: "Male", id: 1 },
    { name: "Female", id: 2 },
    { name: "Adult", id: 3 },
    { name: "Child", id: 4 },
    { name: "Business", id: 5 },
  ];
  // form data error values
  const [errorLabelName, setErrorLabelName] = useState({
    businessType: "",
    businessCategory: "",
    yearsInBusiness: "",
    sentimentType: "",
    customerType: "",
  });
  // state to show response section
  const [isCheck, setIsCheck] = useState(false);
  // state to toggle between loading lines in button
  const [rotatorLine, setRotatorLine] = useState(false);
  // state to show response generated
  const [responseGenerated, setResponseGenerated] = useState("");
  // state to copy the response in the clipboard
  const [copyTextField, setCopyTextField] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  ////////////// change function for input field //////////////
  const handleChange = (e) => {
    setFormData((ps) => {
      const inputValue = e.target.value;
      const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
      const truncatedValue = sanitizedValue.slice(0, 6);
      const validNumber = truncatedValue.replace(/(\..*?)\..*/g, "$1");
      let finalNumber;
      if (validNumber.includes(".")) {
        const [integerPart, decimalPart] = validNumber.split(".");
        const truncatedDecimalPart = decimalPart.slice(0, 2);
        finalNumber = `${integerPart}.${truncatedDecimalPart}`;
      } else {
        finalNumber = validNumber;
      }
      return {
        ...ps,
        yearsInBusiness: finalNumber,
      };
    });
  };

  const handleInputChange = (selectedValue, flag) => {
    if (flag === "business_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        businessType: selectedValue,
      }));
    } else if (flag === "sentiment_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        sentimentType: selectedValue,
      }));
    } else if (flag === "customer_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customerType: selectedValue,
      }));
    }
  };

  ////////////// response generator function //////////////
  const responseGenerator = async () => {
    if (
      formData.businessType &&
      formData.businessCategory &&
      formData.yearsInBusiness &&
      formData.sentimentType.length > 0 &&
      formData.customerType.length > 0
    ) {
      setRotatorLine(true);

      const data = {
        businessType: formData.businessType ? formData.businessType : "",
        businessCategory: formData.businessCategory
          ? formData.businessCategory
          : "",
        yearsInBusiness: formData.yearsInBusiness
          ? formData.yearsInBusiness
          : "",
        sentimentType: formData.sentimentType ? formData.sentimentType : "",
        customerType: formData.customerType ? formData.customerType : "",
      };

      const BusinessProfileAIRes = await BusinessProfileAIAPI(data, () => {
        navigate("/");
      });
      if (BusinessProfileAIRes.status === 200) {
        setIsCheck(true);
        setRotatorLine(false);
        setResponseGenerated(BusinessProfileAIRes.data);
      } else if (BusinessProfileAIRes.status === 429) {
        setLoading(true);
        toast.error(BusinessProfileAIRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setRotatorLine(false);
        toast.error("Internal Server Error", {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
    // else {
    //   setIsCheck(false);
    // }
    setErrorLabelName((prevState) => ({
      ...prevState,
      businessType:
        formData.businessType === "" ? "Please select business type" : "",
      businessCategory:
        formData.businessCategory === ""
          ? "Please input business category"
          : "",
      yearsInBusiness:
        formData.yearsInBusiness === "" ? "Please input a valid year" : "",
      sentimentType:
        formData.sentimentType.length === 0
          ? "Please select a sentiment type"
          : "",
      customerType:
        formData.customerType.length === 0
          ? "Please select a customer type"
          : "",
    }));
  };

  ////////////// function to copy the response //////////////
  const copyText = () => {
    const paragraphElement = document.getElementById("response-generated");
    if (paragraphElement) {
      const textToCopy = paragraphElement.innerText;
      navigator.clipboard.writeText(textToCopy);
      setCopyTextField(true);
      setTimeout(() => {
        setCopyTextField(false);
      }, 2000);
    }
  };

  ////////////// function to scroll down to the response once generated //////////////
  useEffect(() => {
    const copyButton = document.getElementById("copy-button");
    if (copyButton) {
      const buttonPosition =
        copyButton.getBoundingClientRect().top + window.scrollY;
      window.scrollTo(0, buttonPosition);
    }
  }, [responseGenerated]);

  return (
    <>
    {
      loading ? <Loader/>:""
    }
    <div className="shoplocalai-content-wrapper">
      <div className="shoplocalai-section-one">
        <img src={communityXlogo} alt="CommunityX Digital" className="shop-local-logo" style={{width:200}}/>
        <h2>
          <img
            src={subHeadingImage}
            alt="Subheading Image"
            className="subHeadingImage"
          />
          I WANT TO UPDATE MY BUSINESS PROFILE
        </h2>
        <p className="text-center mt-1 bussiness-p_S">
          If you would like to update your business profile, use this AI tool to
          create your new business profile. Select various fields to generate a
          business profile. Please note: Use this tool as a start to update your
          profile. Copy the content generated, modify it as needed and update
          your profile. Sometimes the AI generated content may not be perfect to
          your needs, please review the information carefully.
        </p>
      </div>
      <div className="shoplocalai-section-two">
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Business Type<span className="star-required">* </span>
          </Form.Label>
          <InputGroup
            title={
              formData.businessType
                ? formData.businessType
                : "Select one option"
            }
          >
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <SelectDropdown
                placeHolder="Select one option"
                options={businessOptions}
                inputValue={(selectedValue) => {
                  handleInputChange(selectedValue, "business_Type");
                }}
              />
            </Form.Group>
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.businessType} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Business Category<span className="star-required">* </span>
          </Form.Label>
          <InputGroup className="edit-border">
            <Form.Control
              type="text"
              placeholder="Ex: restaurant, laundry, pluming etc."
              className="custom-formcontrol"
              value={formData.businessCategory}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  businessCategory: e.target.value,
                })
              }
              maxLength={100}
              autoComplete="off"
            />
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.businessCategory} />
        </Form.Group>
        {/* <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Business Category<span className="star-required">* </span>
            <span className="disclaimer_Text">
              (Ex: restaurant, laundry, pluming etc.)
            </span>
          </Form.Label>
          <InputGroup className="edit-border">
            <Form.Control
              type="text"
              placeholder="Enter business category"
              className="custom-formcontrol"
              value={formData.businessCategory}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  businessCategory: e.target.value,
                })
              }
              maxLength={100}
            />
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.businessCategory} />
        </Form.Group> */}
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Years in Business<span className="star-required">* </span>
          </Form.Label>
          <InputGroup className="edit-border">
            <Form.Control
              type="text"
              placeholder="Enter no. of years"
              className="custom-formcontrol"
              name="years_in_business"
              value={formData.yearsInBusiness}
              onChange={(e) => handleChange(e)}
              utoComplete="off"
            />
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.yearsInBusiness} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Sentiment<span className="star-required">* </span>
          </Form.Label>
          <InputGroup
            title={
              formData.sentimentType.length > 0
                ? formData.sentimentType
                : "Select up to 3 sentiments"
            }
          >
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <MultiSelectDropdown
                maxOptions="3"
                placeholder="Select up to 3 sentiments"
                options={sentimentOptions}
                inputValue={(selectedValue) => {
                  handleInputChange(selectedValue, "sentiment_Type");
                }}
              />
            </Form.Group>
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.sentimentType} />
        </Form.Group>
        <Form.Group className="mb-0" controlId="formBasicEmail">
          <Form.Label className="form-label-custom">
            Customer Type<span className="star-required">* </span>
          </Form.Label>
          <InputGroup
            title={
              formData.customerType.length > 0
                ? formData.customerType
                : "Select all that apply"
            }
          >
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <MultiSelectDropdown
                placeholder="Select all that apply"
                options={customerOptions}
                inputValue={(selectedValue) => {
                  handleInputChange(selectedValue, "customer_Type");
                }}
              />
            </Form.Group>
          </InputGroup>
          <ErrorLabel ErrorDisplay={errorLabelName.customerType} />
        </Form.Group>
      </div>
      <div className="generator-div-wrapper business-button-wrapper toggling-content-block">
        <div className="button-div business-button-block">
          {rotatorLine ? (
            <button className="generate-response-button loader-button">
              <ThreeDots
                style={{ position: "absolute" }}
                height="10"
                width="30"
                radius="9"
                color="white"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </button>
          ) : isCheck ? (
            <button className="regenerate-button" onClick={responseGenerator}>
              <img
                loading="lazy"
                src={regnerateIcon}
                className="regnerateIcon"
                alt="Regnerate Icon"
              />
              Regenerate
            </button>
          ) : (
            <button
              className="generate-response-button"
              onClick={responseGenerator}
            >
              Generate Business Profile
            </button>
          )}
        </div>
        <p className="toggling-content">
          (To avoid losing access, please copy the generated content before
          leaving the tab.)
        </p>
      </div>
      {isCheck ? (
        <div className="response-section">
          {/* <p>{responseGenerated}</p> */}
          <p
            id="response-generated"
            dangerouslySetInnerHTML={{ __html: responseGenerated }}
          />
          {responseGenerated ? (
            <button onClick={copyText} id="copy-button">
              {copyTextField ? (
                "Copied!"
              ) : (
                <>
                  <img
                    loading="lazy"
                    src={copyIcon}
                    alt="Copy Icon"
                    className="copyIcon"
                  />
                  Copy
                </>
              )}
            </button>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
    </>
  );
};

export default ShopLocalAIBusinessProfile;
